// extracted by mini-css-extract-plugin
module.exports = {"title":"title___3Hbli"};